import styled from 'styled-components';

export const ContentContainer = styled.div`
  width: 100%;
  height: calc(100% - 80px);

  margin-top: 80px;
  padding: 40px 0px 24px 0px;

  overflow-y: scroll;
  display: flex;

  background-color: ${({ theme }) => theme.colors.greys.lighter};
`;
